// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixedStyle{min-width:240px;left:40px}.fixedStyle,.largeFixedStyle{width:25%;height:calc(100vh - 150px);position:fixed!important;overflow-y:auto;overflow-x:hidden}.largeFixedStyle{left:60px}.mobileStyle{position:static}", ""]);
// Exports
module.exports = exports;
